import request from '@/utils/request'

export function fetchRequestLogs(params = {}) {
  return request.get('/api/request-logs', {
    params
  })
}

export function deleteRequestLogs(ids) {
  return request.delete('/api/request-logs', {
    data: { ids }
  })
}

export function clearRequestLogs() {
  return request.delete('/api/request-logs/all')
}
